// services/ExamService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getExams(params = {}) {
    return api.get(ENDPOINTS.EXAMS.BASE, { params });
}
export function getExamById(id) {
    return api.get(ENDPOINTS.EXAMS.BY_ID(id));
}
export function createExam(payload) {
    return api.post(ENDPOINTS.EXAMS.BASE, payload);
}
export function updateExam(id, payload) {
    return api.patch(ENDPOINTS.EXAMS.BY_ID(id), payload);
}
export function deleteExam(id) {
    return api.delete(ENDPOINTS.EXAMS.BY_ID(id));
}
export function restoreExam(id) {
    return api.post(`${ENDPOINTS.EXAMS.BY_ID(id)}/restore`);
}
export function requestExamValidation(id) {
    return api.post(ENDPOINTS.EXAMS.REQUEST_VALIDATION(id));
}
export function validateExam(id) {
    return api.post(ENDPOINTS.EXAMS.VALIDATE(id));
}
export function reopenExam(id) {
    return api.post(ENDPOINTS.EXAMS.REOPEN(id));
}
export function publishExam(id) {
    return api.post(ENDPOINTS.EXAMS.PUBLISH(id));
}
export function archiveExam(id) {
    return api.post(ENDPOINTS.EXAMS.ARCHIVE(id));
}
export function rejectExam(id, reason) {
    return api.post(ENDPOINTS.EXAMS.REJECT(id), { reason });
}

// Composition de l'examen (questions attachées)
export function getExamQuestions(examId) {
    return api.get(ENDPOINTS.EXAMS.QUESTIONS(examId));
}
export function addExamQuestion(examId, payload) {
    return api.post(ENDPOINTS.EXAMS.QUESTIONS(examId), payload);
}
export function updateExamQuestion(examId, examQuestionId, payload) {
    return api.patch(ENDPOINTS.EXAMS.QUESTION_BY_ID(examId, examQuestionId), payload);
}
export function removeExamQuestion(examId, examQuestionId) {
    return api.delete(ENDPOINTS.EXAMS.QUESTION_BY_ID(examId, examQuestionId));
}
export function neutralizeExamQuestion(examId, examQuestionId, reason = "") {
    return api.post(ENDPOINTS.EXAMS.NEUTRALIZE_QUESTION(examId, examQuestionId), { reason });
}
